import React from "react";
import Button, { ButtonSize, ButtonVariant } from "../../../Button";
import { useTranslation } from "gatsby-plugin-react-i18next";
import Advanced from "../../../../images/sellics-keyword/advanced.svg";
import Universal from "../../../../images/sellics-keyword/universal.svg";
import Brand from "../../../../images/sellics-keyword/brand.svg";
import { PAGE } from "../../../../constants/pages";

interface GoalConfigPanelProps {
  feature?: any;
  onClick: () => void;
  page?: string;
}
const GoalConfigPanel: React.FC<GoalConfigPanelProps> = props => {
  const { onClick, feature, page } = props;
  const { t } = useTranslation();

  const featuresImage = {
    Universal: <Universal />,
    "Brand Based": <Brand />,
    Advanced: <Advanced />
  };

  if (page !== undefined && page === PAGE.SELLICS_JOINS_PERPETUA) {
    return featuresImage[feature?.name];
  }

  return (
    <>
      <div
        className="bg-white shadow rounded-2xl border border-gray-4-light p-6 space-y-6 transition-all"
        style={{
          minWidth: "344px"
        }}
      >
        {feature &&
          feature?.options?.map((item, index) => {
            return (
              <div key={item.name}>
                <p className="text-lg font-semibold mb-3">{item?.name}</p>
                <div className="flex flex-row items-center justify-between">
                  {item?.inputs?.map(input => {
                    return (
                      <React.Fragment key={input.title}>
                        <span>
                          <p className="text-base font-semibold text-gray-2-light mb-2">
                            {input?.title}
                          </p>
                          <div className="w-35 border border-gray-3-light rounded-lg py-2 px-3">
                            {input?.input}
                          </div>
                        </span>
                      </React.Fragment>
                    );
                  })}
                </div>
              </div>
            );
          })}
        <Button
          variant={ButtonVariant.primary}
          size={ButtonSize.large}
          text={t("Launch Goals")}
          onClick={onClick}
          className="mt-8 w-full"
        />
      </div>
    </>
  );
};

export default GoalConfigPanel;
